<template>
  <div class="todo-list">
    <div class="todo-list-filter">
      <v-row class="pa-4">
        <v-col cols="6" class="d-flex align-center gap-8">
          <i class="rd-file-note f-45" style="color: #a9182a"></i>
          <div>
            <section class="font-18 font-w-500">
              สร้างและแก้ไข งานมอบหมาย
            </section>
            <section class="font-14 grey--text">
              ทั้งหมด : {{ total }} รายการ
            </section>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-end">
          <div>
            <button class="btn-todo-list" @click="addTodo">
              <v-icon color="#fff">mdi-file-document-plus-outline</v-icon>
              <span>สร้าง งานมอบหมาย</span>
            </button>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 100px"
          >
            เดือน :
          </section>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateFormat"
                placeholder="เริ่มต้น-สิ้นสุด"
                append-icon="rd-calendar-days"
                color="#a9182a"
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="clearDate()"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              color="#aa0c1e"
              range
              no-title
              @change="changeDate()"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 100px"
          >
            จังหวัด Dealer :
          </section>
          <v-select
            v-model="provinceId"
            :items="provinceList"
            item-text="PROVINCE_NAME"
            item-value="PROVINCE_ID"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            @change="changeProvince()"
          ></v-select>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 100px"
          >
            Dealer :
          </section>
          <v-select
            v-model="shopId"
            :items="shopList"
            item-value="id"
            item-text="name"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            :disabled="!provinceId"
            @change="changeFilter()"
          ></v-select>
        </v-col>
        <v-col cols="6" class="d-flex align-center gap-8">
          <section
            class="font-16 font-w-500 flex-shrink-0"
            style="width: 100px"
          >
            Task Type :
          </section>
          <v-select
            v-model="taskTypeId"
            :items="taskTypeList"
            item-text="name"
            item-value="id"
            placeholder="ทั้งหมด"
            append-icon="mdi-chevron-down"
            color="#a9182a"
            outlined
            hide-details
            dense
            clearable
            @change="changeFilter()"
          ></v-select>
        </v-col>
        <v-col cols="12" style="position: relative">
          <input
            v-model="search"
            class="input-search"
            type="text"
            placeholder="ค้นหาชื่อร้าน"
            @keypress.enter="changeFilter()"
          />
          <button class="input-search--btn" @click="changeFilter()">
            <v-icon color="#fff">mdi-magnify</v-icon>
          </button>
        </v-col>
      </v-row>
    </div>

    <div class="todo-list-main">
      <div
        v-if="todoListNew.length + todoList.length === 0"
        class="d-flex align-center justify-center pa-10"
      >
        <span>ไม่พบข้อมูล</span>
      </div>

      <div v-else class="d-flex justify-center">
        <div class="todo-list-table">
          <div class="todo-list-table--header">
            <section style="flex-basis: 100px">
              <span>ลำดับ</span>
            </section>
            <section style="flex-basis: 150px">
              <div>
                <span>ชื่อร้านค้าช่วง</span>
                <br />
                <span>BPNO</span>
              </div>
            </section>
            <section style="flex-basis: 150px">
              <span>จังหวัด/อำเภอ</span>
            </section>
            <section style="flex-basis: 150px">
              <span>ประเภทงาน</span>
            </section>
            <section style="flex-basis: 150px">
              <span>ชื่องาน</span>
            </section>
            <section style="flex-basis: 180px">
              <span>กำหนดเสร็จ</span>
            </section>
            <section style="flex-basis: 150px">
              <span>Preview</span>
            </section>
          </div>

          <TodoListFormRow
            v-for="item in todoListNew"
            :key="item.todolist_id"
            index="-"
            :detailProp="item"
            :listCustomer="listCustomer"
            :taskTypeList="taskTypeList"
            @saveNewTodo="saveNewTodo"
            @removeNewTodo="removeNewTodo"
          />

          <TodoListFormRow
            v-for="(item, index) in todoList"
            :key="item.todolist_id"
            :index="(page - 1) * limit + index + 1"
            :detailProp="item"
            :listCustomer="listCustomer"
            :taskTypeList="taskTypeList"
            @updateTodo="updateTodo()"
            @removeTodo="getTodoList()"
          />
        </div>
      </div>

      <div class="my-5">
        <v-pagination
          v-model="page"
          :length="pageTotal"
          color="#a9182a"
          circle
          @input="getTodoList"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { v4 as uuid } from 'uuid'
import TodoListFormRow from '@/components/v2/todoList/TodoListFormRow.vue'

export default {
  components: {
    TodoListFormRow,
  },
  data() {
    return {
      date: [],
      dateMenu: false,
      provinceId: '',
      provinceList: [],
      todoListNew: [],
      shopId: '',
      shopList: [],
      taskTypeId: '',
      taskTypeList: [],
      search: '',
      page: 1,
      pageTotal: 0,
      limit: 10,
      total: 0,
      todoList: [],
      listCustomer: [],
    }
  },
  computed: {
    dateFormat() {
      if (this.date.length === 2) {
        const startDate = dayjs(this.date[0]).format('DD/MM/YYYY')
        const endDate = dayjs(this.date[1]).format('DD/MM/YYYY')
        return `${startDate} - ${endDate}`
      }
      return ''
    },
  },
  mounted() {
    this.$store.dispatch('setTitle', 'To Do List')
    this.getProvinceList()
    this.getTaskType()
    this.getListCustomer()
    this.getTodoList()
  },
  methods: {
    changeDate() {
      this.date.sort((a, b) => new Date(a) - new Date(b))
      this.changeFilter()
    },
    clearDate() {
      this.date = []
      this.changeFilter()
    },
    changeProvince() {
      this.shopId = ''
      this.getShopList()
      this.changeFilter()
    },
    async getListCustomer() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPINew}/web/?act=list_customer`,
          {
            user_id: this.$store.state.auth.user.id,
          },
        )

        if (res.status === 200) {
          this.listCustomer = res.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getProvinceList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/provinces`,
          {},
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.provinceList = res.data.provinces
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getShopList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/shopList`,
          {
            provinces: this.provinceId,
          },
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.shopList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getTaskType() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/getTasktype`,
          {},
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.taskTypeList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeFilter() {
      this.page = 1
      this.getTodoList()
    },
    async getTodoList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/todolist/getReciveTaskTodolist_OSR`,
          {
            start_date:
              this.date.length === 2
                ? dayjs(this.date[0]).format('YYYY-MM-DD')
                : '',
            end_date:
              this.date.length === 2
                ? dayjs(this.date[1]).format('YYYY-MM-DD')
                : '',
            shop_id: this.shopId,
            task_type: this.taskTypeId,
            provinces: this.provinceId,
            search: this.search,
            page: this.page,
            limit: this.limit,
          },
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.todoList = res.data.items.list.map((item) => ({
            ...item,
            isEdit: false,
            isNew: false,
          }))
          this.pageTotal = res.data.items.page.total
          this.total = res.data.items.page.total_row
        }
      } catch (error) {
        console.error(error)
      }
    },
    saveNewTodo(detail) {
      this.removeNewTodo(detail.todolist_id)
      this.getTodoList()
    },
    updateTodo() {
      this.getTodoList()
    },
    removeNewTodo(id) {
      this.todoListNew = this.todoListNew.filter(
        (item) => item.todolist_id !== id,
      )
    },
    addTodo() {
      this.todoListNew.push({
        todolist_id: uuid(),
        customer_id: '',
        task_type: '',
        detail: '',
        due_date: dayjs().format('YYYY-MM-DD'),
        isEdit: true,
        isNew: true,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.todo-list {
  padding-top: 4rem;
  background: #e4e7ec;
  min-height: 100dvh;
}
.todo-list-filter {
  background: #fff;
  border-radius: 0px 0px 20px 20px;
}
.btn-todo-list {
  border-radius: 6px;
  background: #a9182a;
  color: #fff;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
.input-search {
  border-radius: 8px;
  padding: 0.5rem;
  border: 1px solid #d2d2d2;
  background: #fff;
  width: 100%;
  height: 40px;

  &--btn {
    position: absolute;
    right: 0;
    width: 40px;
    height: 40px;
    background: #a9182a;
    border-radius: 0px 8px 8px 0px;
  }
}

.todo-list-main {
  background: #fff;
  border-radius: 20px;
  margin: 1rem;
  padding: 1rem;
}

.todo-list-table {
  overflow-x: auto;
  border-radius: 8px;

  &--header {
    display: flex;
    width: 1030px;
    background: #eaeaea;
    font-size: 14px;

    & section {
      height: 52px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & section:not(:last-child) {
      border-right: 1px solid #bbbdbf;
    }
  }
}
</style>
